       
<!-- Aqui se cargan todas las paginas Iniciales -->
<router-outlet></router-outlet>

  
 


